import React from "react";
import PdfViewer from "../../PdfViewer";

const MesaAyudaCliente = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/formato-mesa-ayuda-cliente.pdf`;
  /*const pdfUrl = "/pdf/formato-mesa-ayuda-cliente.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Mesa de Ayuda al Cliente</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default MesaAyudaCliente;
